import React, { useContext } from 'react';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';

let ifm;

/**
 * iframeDownload
 * When to use:
 *   the resource to download is cross-origin without CORS header
 * @param {string} url - url to download
 * @param {string} statusHandler - callback function to check file is loaded
 * @returns {void}
 */
export function iframeDownload(url, statusHandler) {
  if (!ifm) {
    ifm = document.createElement('iframe');
    ifm.style.display = 'none';
    if (statusHandler) {
      const timer = setInterval(() => {
        try {
          const iframeDoc = ifm.contentDocument || ifm.contentWindow.document;
          if (iframeDoc.readyState === 'complete') {
            clearInterval(timer);
            statusHandler(iframeDoc.readyState);
          }
          clearInterval(timer);
        } catch (e) {
          clearInterval(timer);
          statusHandler('fail', e);
        }
      }, 500);
    }

    document.body.appendChild(ifm);
  }
  ifm.src = url;
}

export function useIframeDownload() {
  const instrumentation = useContext(InstrumentationContext);
  const logger = instrumentation.createScenarioAndActivity({
    scenarioName: 'iframeDownloadScenario',
    activityName: 'iframeDownloadActivity',
  }).activity;

  return function iframeDownloadWithMonitoring(url) {
    iframeDownload(url, (status, err) => {
      if (status === 'complete') {
        logger.trace(`file download completed.status:${status},URL:${url}`);
      } else {
        logger.error(`file download failed.status:${status},URL:${url} error:${JSON.stringify(err)}`);
      }
    });
  };
}

export function withIframeDownload(Comp) {
  return function WrappedComp(props) {
    const iframeDownloadWithMonitoring = useIframeDownload();
    return (<Comp {...props} iframeDownload={iframeDownloadWithMonitoring} />);
  };
}
